import {
  StapleTableHeader,
  StapleTableHeading,
  StapleTableBody,
  StapleTableRow,
  StapleTableCell,
  StapleTable,
} from '@insurancemenu/imenu-components-lib';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useRootStore } from 'store/rootStore';
import { SubscriberInfoContentStyled } from './styles';

const SubscriberInfo = observer((): JSX.Element => {
  const {
    reviewSubscriberStore: { subscriberFormData },
  } = useRootStore();

  const convertedFormData = toJS(subscriberFormData);

  return (
    <SubscriberInfoContentStyled>
      <StapleTable totalElements={Object.keys(convertedFormData).length}>
        <StapleTableHeader>
          <StapleTableRow>
            <StapleTableHeading>Question</StapleTableHeading>
            <StapleTableHeading>Answer</StapleTableHeading>
          </StapleTableRow>
        </StapleTableHeader>
        <StapleTableBody>
          {Object.keys(convertedFormData).map((key) => (
            <StapleTableRow key={key}>
              <StapleTableCell>{key}</StapleTableCell>
              <StapleTableCell>{convertedFormData[key]}</StapleTableCell>
            </StapleTableRow>
          ))}
        </StapleTableBody>
      </StapleTable>
    </SubscriberInfoContentStyled>
  );
});

export default SubscriberInfo;
